export default {"src":"/_next/static/media/college3.4d6f17d8.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};